import { z } from "zod";
import { commercialDriveWatchStatusSchema } from "./commercial-drive-watch.js";
export const commercialDriveWatchOverviewSchema = commercialDriveWatchStatusSchema.extend({
    deployment: z.object({
        enabled: z.boolean(),
        folderId: z
            .string()
            .regex(/^[A-Za-z0-9_-]{10,200}$/)
            .nullable(),
        scope: z.literal("DIRECT_CHILDREN"),
        checkCadence: z.literal("DAILY"),
        monthlyDay: z.literal(1),
        monthlyLocalTime: z.literal("06:00"),
        timeZone: z.literal("America/Sao_Paulo"),
    }),
});
//# sourceMappingURL=commercial-drive-watch-overview.js.map